export default "__VITE_ASSET__BTjYapG8__"